import { useReporting } from '@/hooks/useReporting';
import useRouteInfo from '@/hooks/useRouteInfo';
import { ProviderType } from '@/reporting';
import { useCallback, useEffect } from 'react';

/**
 * Personality Fit 专题页埋点 Hook
 * 对齐 Vue 文档的事件：
 * - VarietyGirlPage_View（页面浏览）
 * - VarietyGirlPageMkt_Exp（资源位曝光）
 * - VarietyGirlPageMkt_Click（资源位点击）
 */
export function usePersonalityFitTracking() {
  const { trackEvent } = useReporting();
  const { getFromRouterInfo } = useRouteInfo();

  const pageView = useCallback(() => {
    const { refer_page_name, refer_url_path } = getFromRouterInfo();
    trackEvent(
      {
        eventName: 'VarietyGirlPage_View',
        properties: {
          refer_page_name,
          refer_url_path,
        },
      },
      [ProviderType.SENSORS],
    );
  }, [trackEvent, getFromRouterInfo]);

  const trackMktExp = useCallback(
    (params: {
      mkt_name: string;
      shop_sku?: string;
      business_sku?: string;
      product_sku?: string;
      group_id?: string | number;
    }) => {
      trackEvent(
        {
          eventName: 'VarietyGirlPageMkt_Exp',
          properties: params,
        },
        [ProviderType.SENSORS],
      );
    },
    [trackEvent],
  );

  const trackMktClick = useCallback(
    (params: {
      mkt_name: string;
      shop_sku?: string;
      business_sku?: string;
      product_sku?: string;
      group_id?: string | number;
    }) => {
      trackEvent(
        {
          eventName: 'VarietyGirlPageMkt_Click',
          properties: params,
        },
        [ProviderType.SENSORS],
      );
    },
    [trackEvent],
  );

  useEffect(() => {
    pageView();
  }, [pageView]);

  return { pageView, trackMktExp, trackMktClick };
}

export default usePersonalityFitTracking;
